import { FaFileAlt, FaLinkedin, FaGithub } from 'react-icons/fa';

const Header = () => {

    return (
        <div className="header">
            <img className="profile-pic" src="/profile-pic.png" alt="Andrew C. Kim" />
            <div className="header-content">
                <div className="title">
                    <h1>Andrew Kim</h1>
                    <h4>Software Developer | SDET</h4>
                </div>
                <div className="aboutme">
                    <p>
                        Passionate Software Developer focused on full stack development and Data Engineering.
                    </p>
                    <p>
                        Aiming to bring a positive impact to the world with technology.
                    </p>
                </div>
                <div className="header-buttons">
                    <a href="/Resume.pdf" target="_blank" rel="noopener noreferrer" className="btn" title="Resume">
                        <FaFileAlt />
                    </a>
                    <a href="https://www.linkedin.com/in/andrewkim0514/" target="_blank" rel="noopener noreferrer" className="btn" title="LinkedIn">
                        <FaLinkedin />
                    </a>
                    <a href="https://github.com/andychokim" target="_blank" rel="noopener noreferrer" className="btn" title="GitHub">
                        <FaGithub />
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Header